import DOMPurify from 'dompurify';
import { FORUM_RICH_TEXT_ATTRS, FORUM_RICH_TEXT_TAGS } from './sanitizeConfig';

// gloss
const COMMENT_TAGS = [...FORUM_RICH_TEXT_TAGS, 'u', 's'] as const;
const COMMENT_ATTRS = [...FORUM_RICH_TEXT_ATTRS, 'width', 'height'] as const;

const IMG_CLASS = 'max-w-full max-h-[500px] w-auto h-auto object-contain rounded-lg my-2 cursor-zoom-in';

// gloss
export const sanitizeCommentHtml = (html: string | null | undefined): string => {
  if (!html) return '';

  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
    if (node.tagName === 'IMG') {
      node.setAttribute('class', IMG_CLASS);
      node.setAttribute('loading', 'lazy');
      const src = node.getAttribute('src');
      if (src && node.parentNode && node.parentNode.tagName !== 'A') {
        const link = node.ownerDocument.createElement('a');
        link.setAttribute('href', src);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
        node.parentNode.insertBefore(link, node);
        link.appendChild(node);
      }
    }
  });

  try {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [...COMMENT_TAGS],
      ALLOWED_ATTR: [...COMMENT_ATTRS],
    });
  } finally {
    // why: must remove the DOMPurify hook in a finally block — an uncaught throw leaves it
    // why: registered globally for later calls.
    DOMPurify.removeHook('afterSanitizeAttributes');
  }
};
